<div style="margin: 0;padding: 0;height:100%;width:100%">
    <div class="header">
        <div>
            车辆详情
        </div>
        <div>
            <i class="pi pi-times p-cursor" (click)="closeDetail()"></i>
        </div>
    </div>
    <div class="body" style="position: relative;">
        <table>
            <tr style="width:100%;height:100%;">
                <td class="panel-left">
                    <!-- 左 -->
                    <div class="panel-detail panel-background">
                        <div class="panel-detail-header">
                            <div class="company-name">
                                {{localTruckDetail['plateNumber']}}
                            </div>
                            <div class="company-tel">
                                <img src="assets/icon/map-location.png" alt="">&nbsp;
                                <span *ngIf="localTruckDetail['formattedAddress']">
                                        {{localTruckDetail['formattedAddress']}}
                                    <span class="auditor" [pTooltip]="'定位时间：'+this.bc.setCreateTime(localTruckDetail['addTime']*1000)"
                                        tooltipPosition="top">（{{this.bc.dateDiff(localTruckDetail['addTime']*1000)}}）
                                    </span>
                                </span>
                                <span class="auditor" *ngIf="!localTruckDetail['formattedAddress']">暂无</span>
                            </div>
                            <div class="panel-detail-status p-d-flex p-ai-center p-jc-center">
                                <!-- <div class="recentPosition p-mr-3" *ngIf="localTruckDetail['plateNumber'].length==8"> -->
                                    <img *ngIf="localTruckDetail['plateNumber'] && localTruckDetail['plateNumber'].length==8" class="p-mr-3" pTooltip="新能源" tooltipPosition="top" src="assets/icon/tram.png" alt="">
                                <!-- </div> -->

                                <div [class]="localTruckDetail['useStatus']==0 ? 'company-status':'company-permit'">
                                    {{this.useStatus[localTruckDetail['useStatus']]}}</div>
                                <div class="company-contract" *ngIf="localTruckDetail['checkFlag']==1">
                                    {{checkFlag[localTruckDetail['checkFlag']]}}</div>
                                <div class="company-success" *ngIf="localTruckDetail['checkFlag']==2">
                                    {{checkFlag[localTruckDetail['checkFlag']]}}</div>
                                <div class="company-permit" *ngIf="localTruckDetail['checkFlag']==3">
                                    不通过原因：{{localTruckDetail['checkLog']}}</div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay']) > 0">
                                    道路运输证{{this.bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localTruckDetail['optCertExpireTime'],'',localTruckDetail['expiredWarnDay']) < 0">
                                    道路运输证已过期{{this.bc.getExpireDays(localTruckDetail['optCertExpireTime'],1,localTruckDetail['expiredWarnDay'])}}天
                                </div>

                                <div class="company-contract p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay']) > 0">
                                    经营许可证{{this.bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay'])}}天后过期
                                </div>
                                <div class="company-permit p-mr-3"
                                    *ngIf="this.bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],'',localTruckDetail['expiredWarnDay']) < 0">
                                    经营许可证已过期{{this.bc.getExpireDays(localTruckDetail['businessCertificateExpireTime'],1,localTruckDetail['expiredWarnDay'])}}天
                                </div>
                            </div>
                        </div>
                        <div class="hr"></div>
                        <!-- 基础详情表单 -->
                        <form class="detail-form" action="">
                            <!-- <div class="table-title">车辆信息</div> -->
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车主姓名
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['ownName']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆属性
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.isPersonalMap[localTruckDetail['isPersonal']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        业户社会信用代码
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['ownCarrierId']}}
                                    </div>
                                    <div class="table-tr">
                                        挂车车牌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['trailerPlateNumber']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        挂车车牌颜色
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        <ng-container *ngIf="!loadingTruckInfo">
                                            {{localTruckDetail['trailerPlateColor'] !== null && localTruckDetail['trailerPlateColor'] !== undefined && localTruckDetail['trailerPlateColor'] !== '' ? (localTruckDetail['trailerPlateColor'] === 0 ? '黄色' : plateColorMap[localTruckDetail['trailerPlateColor']]) : ''}}
                                        </ng-container>
                                    </div>
                                    <div class="table-tr">
                                        车辆类型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.vehicleTypeMap[localTruckDetail['vehicleType']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆长度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['length']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆宽度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['width']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆高度
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['height']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆核载
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['loadWeight']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆满载
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['fullLoadWeight']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车辆体积
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['trailerVolume']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆品牌
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['model']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        车牌颜色
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.plateColorMap[localTruckDetail['plateColor']]}}
                                    </div>
                                    <div class="table-tr">
                                        车辆能源类型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.energyTypeMap[localTruckDetail['energyType']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        使用性质
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['useCharacter']}}
                                    </div>
                                    <div class="table-tr">
                                        车辆识别代码
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['truckVin']}}
                                    </div>
                                </div>
                                <!-- 隐藏车型和车长字段 -->
                                <!-- <div class="table-rows">
                                    <div class="table-tr">
                                        车型
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['truckType'] && localTruckDetail['truckType'] != 0 ? (this.truckModelMap[localTruckDetail['truckType']] || localTruckDetail['truckType']) : '-'}}
                                    </div>
                                    <div class="table-tr">
                                        车长
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['truckSize'] && localTruckDetail['truckSize'] != 0 ? this.truckSizeMap[localTruckDetail['truckSize']] : '-'}}
                                    </div>
                                </div> -->
                                <div class="table-rows">
                                    <div class="table-tr">
                                        核定载客人数
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['seats'] || '-'}}
                                    </div>
                                    <div class="table-tr">
                                        轴数
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo">
                                        </p-skeleton>
                                        {{localTruckDetail['axleCount'] || '-'}}
                                    </div>
                                </div>
                            </div>
                        </form>
                        <!-- 我的车辆表单 -->
                        <form class="detail-form" action="">
                            <!-- <div class="table-title">证件信息</div> -->
                            <div class="table-detail">
                                <div class="table-rows">
                                    <div class="table-tr">
                                        道路运输证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['optCertNo']}}
                                    </div>
                                    <div class="table-tr">
                                        道路运输证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['optCertExpireTime']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        经营许可证号
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['businessCertificate']}}
                                    </div>
                                    <div class="table-tr">
                                        经营许可证失效日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['businessCertificateExpireTime']*1000,'yyyy-MM-dd')}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        行驶证发证机关
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['issuingOrganizations']}}
                                    </div>
                                    <div class="table-tr">
                                        行驶证注册日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['registerDate']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        行驶证发证日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['issueDate']}}
                                    </div>
                                    <div class="table-tr">
                                        入网状况
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.isOnlineMap[localTruckDetail['isOnline']]}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        年检到期日期
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['vehicleExaminedExpirationDate']}}
                                    </div>
                                    <div class="table-tr">
                                        备注
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['remark']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        审核时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['checkTime']*1000)}}
                                    </div>
                                    <div class="table-tr">
                                        审核人员
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{localTruckDetail['checkName']}}
                                    </div>
                                </div>
                                <div class="table-rows">
                                    <div class="table-tr">
                                        创建时间
                                    </div>
                                    <div class="table-td">
                                        <p-skeleton width="10rem" height="2rem" *ngIf="loadingTruckInfo"></p-skeleton>
                                        {{this.bc.setCreateTime(localTruckDetail['createTime']*1000)}}
                                    </div>
                                </div>
                            </div>
                        </form>

                        <!-- 关联信息 -->
                        <form class="detail-form" action="">
                            <div class="table-title">关联信息</div>
                            <p-accordion>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">司机（{{this.relDriverList.length}}）
                                        <div *ngFor="let item of relDriverList;let i = index">
                                            <p-chip *ngIf="i<6" [label]="item['driverName']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">司机姓名</div>
                                            <div class="table-line">联系电话</div>
                                            <div class="table-line">人车照片</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relDriverList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relDriverList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                <!-- <a href="javascript:;" pRipple class="edit-font p-mr-2"
                                                    (click)="showDriverDetail(item)">{{item.driverName}}
                                                </a> -->
                                                {{item.driverName}}
                                            </div>
                                            <div class="table-line">
                                                {{item.driverPhone}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkDriverTruckPhoto(item)"
                                                        style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <!-- 车主模块已隐藏 -->
                                <p-accordionTab>
                                    <ng-template pTemplate="header">挂靠协议</ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">车牌号</div>
                                            <div class="table-line">车辆属性</div>
                                            <div class="table-line">挂靠协议</div>
                                        </div>
                                        <div class="table-rows" *ngIf="!localTruckDetail['plateNumber']">
                                            <div class="table-line" *ngIf="!loadingTruckInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingTruckInfo">
                                                <p-skeleton *ngIf="loadingTruckInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngIf="localTruckDetail['plateNumber']">
                                            <div class="table-line">
                                                {{localTruckDetail['plateNumber']}}
                                            </div>
                                            <div class="table-line">
                                                {{this.isPersonalMap[localTruckDetail['isPersonal']]}}
                                            </div>
                                            <div class="table-line">
                                                <ng-container
                                                    *ngIf="!localTruckDetail['agreementPhoto'] || localTruckDetail['agreementPhoto'] == ''">
                                                    <span style="color: red;">未上传</span>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="localTruckDetail['agreementPhoto'] && localTruckDetail['agreementPhoto'] != ''">
                                                    <a href="javascript:;" pRipple class="edit-font"
                                                        (click)="checkAffiliationAgreement()"
                                                        style="color: #4ea844;">已上传</a>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <!-- <p-accordionTab>
                                    <ng-template pTemplate="header">代理商（{{this.relAgentList.length}}）
                                        <div *ngFor="let item of relAgentList;let i = index">
                                            <p-chip [label]="item['agentName']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">代理商名称</div>
                                            <div class="table-line">联系人</div>
                                            <div class="table-line">联系电话</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relAgentList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relAgentList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                {{item.agentName}}
                                            </div>
                                            <div class="table-line">
                                                {{item.contactName}}
                                            </div>
                                            <div class="table-line">
                                                {{item.contactPhone}}
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab>
                                <p-accordionTab>
                                    <ng-template pTemplate="header">托运方（{{this.relCusList.length}}）
                                        <div *ngFor="let item of relCusList;let i = index">
                                            <p-chip [label]="item['name']" style="margin-left: 10px;"
                                                styleClass="p-mr-2 custom-chip"></p-chip>
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="content">
                                        <div class="table-rows" style="background-color: var(--surface-d)">
                                            <div class="table-line">序号</div>
                                            <div class="table-line">托运方名称</div>
                                            <div class="table-line">联系人</div>
                                            <div class="table-line">联系电话</div>
                                        </div>
                                        <div class="table-rows" *ngIf="relCusList.length==0">
                                            <div class="table-line" *ngIf="!loadingRelInfo">
                                                暂无数据
                                            </div>
                                            <div class="table-line" *ngIf="loadingRelInfo">
                                                <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                            </div>
                                        </div>
                                        <div class="table-rows" *ngFor="let item of relCusList;let i = index">
                                            <div class="table-line">
                                                {{i+1}}
                                            </div>
                                            <div class="table-line">
                                                {{item.name}}
                                            </div>
                                            <div class="table-line">
                                                {{item.legalPerson}}
                                            </div>
                                            <div class="table-line">
                                                {{item.legalPhone}}
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-accordionTab> -->
                            </p-accordion>
                        </form>
                        <!-- 关联司机
                        <form class="detail-form" action="">
                            <div class="table-title">关联司机</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">司机姓名</div>
                                    <div class="table-line">联系电话</div>
                                    <div class="table-line">人车照片</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relDriverList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showAgentDetail(localAgentorDetail)">{{item.driverName}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.driverPhone}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <ng-container
                                            *ngIf="item.driverTruckPhoto == '' || item.driverTruckPhoto == null">
                                            <span style="color: red;">未上传</span>
                                        </ng-container>
                                        <ng-container
                                            *ngIf="item.driverTruckPhoto != '' && item.driverTruckPhoto != null">
                                            <a href="javascript:;" pRipple class="edit-font"
                                                style="color: #4ea844;">已上传</a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 关联车主
                        <form class="detail-form" action="">
                            <div class="table-title">关联车主</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">车主姓名</div>
                                    <div class="table-line">联系电话</div>
                                    <div class="table-line">挂靠协议</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relTeamList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showAgentDetail(localAgentorDetail)">{{item.realname}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.mobilePhone}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <ng-container *ngIf="item.agreementPhoto == '' || item.agreementPhoto == null">
                                            <span style="color: red;">未上传</span>
                                        </ng-container>
                                        <ng-container *ngIf="item.agreementPhoto != '' && item.agreementPhoto != null">
                                            <a href="javascript:;" pRipple class="edit-font"
                                                style="color: #4ea844;">已上传</a>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 关联代理商
                        <form class="detail-form" action="">
                            <div class="table-title">关联代理商</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">代理商名称</div>
                                    <div class="table-line">联系人</div>
                                    <div class="table-line">联系电话</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relAgentList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showAgentDetail(localAgentorDetail)">{{item.agentName}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.contactName}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.contactPhone}}
                                    </div>
                                </div>
                            </div>
                        </form>-->
                        <!-- 关联货主
                        <form class="detail-form" action="">
                            <div class="table-title">关联托运方</div>
                            <div class="table-detail">
                                <div class="table-rows" style="background-color: var(--surface-d)">
                                    <div class="table-line">序号</div>
                                    <div class="table-line">托运方名称</div>
                                    <div class="table-line">联系人</div>
                                    <div class="table-line">联系电话</div>
                                </div>
                                <div class="table-rows" *ngFor="let item of relCusList;let i = index">
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{i+1}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        <a href="javascript:;" pRipple class="edit-font"
                                            (click)="showShipperDetail(localAgentorDetail)">{{item.name}}
                                        </a>
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.legalPerson}}
                                    </div>
                                    <div class="table-line">
                                        <p-skeleton *ngIf="loadingRelInfo"></p-skeleton>
                                        {{item.legalPhone}}
                                    </div>
                                </div>
                            </div>
                        </form>-->
                    </div>
                </td>
                <td class="panel-right">
                    <!-- 右 -->
                    <div class="panel-list panel-background">
                        <!-- tab -->
                        <div class="panel-right-top">
                            <!-- tab -->
                            <div *ngFor="let item of tabList index as i" class="tabBar">
                                <div class="tabBar-item" [ngClass]="activeIndex == i ? 'active' : ''"
                                    (click)="handleTabClick(i)">
                                    {{item}}
                                </div>
                            </div>
                        </div>
                        <!-- 统计数据 -->
                        <div *ngIf="activeIndex == 0" style="margin-top: 1.714286rem;">
                            <!-- 图表区域 -->
                            <div class="chart p-d-flex p-ai-center p-jc-around">
                                <div class="chart-container">
                                    <div class="panel-right-title" style="position: absolute;top: -2px;left: 0;">车辆数据
                                    </div>
                                    <p-chart type="bar" width="auto" height="300px" [responsive]="true"
                                        [data]="chartData" [options]="chartOptions">
                                    </p-chart>
                                </div>
                            </div>

                            <div class='count-container p-d-flex p-ai-center p-jc-between'>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item1.png" alt="">
                                    <div class="count-item-title">累计运单数(单)</div>
                                    <div class="count-item-num">{{totalNum}}</div>
                                </div>
                                <div class="count-hr"></div>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item2.png" alt="">
                                    <div class="count-item-title">累计运输重量(吨)</div>
                                    <div class="count-item-num">{{totalWeight}}</div>
                                </div>
                                <div class="count-hr"></div>
                                <div class="count-item">
                                    <img class="count-item-img" src="assets/icon/count-item3.png" alt="">
                                    <div class="count-item-title">累计行驶公里数</div>
                                    <div class="count-item-num">{{totalKilometre}}</div>
                                </div>
                            </div>

                            <div class="exp-container p-d-flex p-ai-center p-jc-between" style="margin-top: 20px;">
                                <div class="exp-item">
                                    <div [class]="ringRatioNum>=0 ? 'exp-item-left' : 'exp-item-left exp-up'">
                                        <img [src]="ringRatioNum>=0 ? 'assets/icon/up1.png' : 'assets/icon/fell1.png' " alt="">
                                    </div>
                                    <div class="exp-item-right">
                                        <div class="exp-item-title">发运量</div>
                                        <div class="exp-item-num">{{ringRatioNum}}%</div>
                                        <div class="exp-item-percent"><span>环比上月</span> </div>
                                    </div>
                                </div>
                                <div class="exp-item">
                                    <div [class]="ringRatioWeight>=0 ? 'exp-item-left' : 'exp-item-left exp-up'">
                                        <img [src]="ringRatioWeight>=0 ? 'assets/icon/up1.png' : 'assets/icon/fell1.png' " alt="">
                                    </div>
                                    <div class="exp-item-right">
                                        <div class="exp-item-title">运输吨数</div>
                                        <div class="exp-item-num">{{ringRatioWeight}}%</div>
                                        <div class="exp-item-percent"><span>环比上月</span> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 照片资料 -->
                        <div *ngIf="activeIndex == 1">
                            <div class="photo-detail">
                                <!--图片描述 -->
                                <div class="img-describe">{{imgDescribe}}</div>
                                <div class="img-container">
                                    <!-- 大图 -->
                                    <div class="img-preview">
                                        <img image-viewer (click)="previewThumbnailImage()" *ngIf="imgPriview || thumbnailImageSrc.length>0"
                                            [src]="imgPriview?imgPriview:thumbnailImageSrc[0]['url']"
                                            class="img-preview-img">
                                    </div>
                                    <!-- 功能区 -->
                                    <div class="function-container">
                                        <div class="function-item turnLeft" (click)="handleTurnLeft()">
                                            <img src="assets/icon/tleft.png" alt="">
                                        </div>
                                        <div class="function-item turnRight" (click)="handleTurnright()">
                                            <img src="assets/icon/tright.png" alt="">
                                        </div>
                                    </div>
                                </div>
                                <!-- 小图列表 -->
                                <div class="img-list">
                                    <div class="img-list-previous">
                                        <img src="assets/icon/Vector 34.png" alt="">
                                    </div>
                                    <!-- 遍历 -->
                                    <div style="margin: 0 40px;" class="p-d-flex p-ai-center p-jc-center">
                                        <div class="img-list-item" [ngClass]="previewImgIndex == i? 'onactive':''"
                                            *ngFor="let item of thumbnailImageSrc index as i">
                                            <img (click)="handlePreviewImgClick(item,i)" class="" [src]="item.url" />
                                            <div class="img-describe-little-mask">
                                                <div class="img-describe-little">{{item.title}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="img-list-next">
                                        <img src="assets/icon/Vector 35.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>


<!--查看法大大协议开始-->
<p-dialog [header]="agreeHeaderTitle" class="edit-order" *ngIf="showFadadaDriverFlag" [(visible)]="showFadadaDriverFlag" position="center" [dismissableMask] = "true"
        [modal]="true" [style]="{width:'60%', overFlow:'auto'}" [baseZIndex]="10000">
    <iframe sandbox="allow-same-origin allow-scripts allow-top-navigation allow-forms" scrolling='auto' frameborder='0' [src]="safeUrl" [style]="{width:'100%',height:'700px'}"></iframe>
</p-dialog>
<!--查看法大大协议结束-->


<!-- 查看图片 -->
<p-dialog *ngIf="myTruck['TeamTruckPhotoPicFlag']" [(visible)]="myTruck['TeamTruckPhotoPicFlag']" position="center"
    [draggable]="true" [resizable]="false" [modal]="true"  [header]='myTruck.truckPicDetailHeader'  class="edit-order"
    [style]="{width:'60%', overFlow:'auto'}">
    <div class="p-d-flex p-ai-center" style="flex-wrap: wrap;min-height: 400px;">

    <!-- <div id="pic" class="imgs-item" *ngFor="let photo of departPhotos" >
        <img [src]="photo" alt="" image-viewer style="width:165px;height:165px;">

    </div> -->

    <div class="img-preview" *ngFor="let photo of departPhotos" >
        <img image-viewer (click)="previewThumbnailImages(photo)"
            [src]="photo"
            class="img-preview-img">
    </div>
</div>

    <ng-template pTemplate="footer">
        <button pButton pRipple icon="pi pi-times" type="button" label="取消"
            (click)="this.myTruck['TeamTruckPhotoPicFlag'] = false"
            class="p-button-raised p-button-text p-button-plain"></button>
    </ng-template>
</p-dialog>



<!-- 司机详情 -->
<p-detail-sidebar *ngIf="showDriverFlag" [(visible)]="showDriverFlag" [showCloseIcon]="false"
    position="right" [style]="{width: percentWidth - 10 + '%'}" transitionOptions="600ms ease-in-out" appendTo="body">
    <app-driver-detail [driverDetail]="driverDetail" (onClose)="showTruckDetailDialog = false"
        [percentWidth]="percentWidth - 10">
    </app-driver-detail>
</p-detail-sidebar>
